import { createContext, useCallback, useContext, useRef, useState } from "react";
import { ConfirmDialog } from "./ui/confirm-dialog";

/**
 * Conferme del gestionale, uguali in tutte le pagine.
 *
 * Prima ogni pagina usava la finestrella del browser (window.confirm), che
 * appare con lo stile del sistema e non permette di spiegare bene cosa sta per
 * succedere.
 *
 * Uso:  const conferma = useConferma();
 *       if (!(await conferma({ titolo: "...", descrizione: "...", pericoloso: true }))) return;
 *
 * RETEE DI SICUREZZA: se per qualsiasi motivo il provider non fosse montato,
 * il contesto ricade sulla finestrella del browser. Cosi' una conferma non puo'
 * sparire per errore lasciando partire un'azione pericolosa.
 */
const ContestoConferma = createContext((opzioni = {}) => {
  const testo = [opzioni.titolo, opzioni.descrizione].filter(Boolean).join("\n\n");
  return Promise.resolve(window.confirm(testo || "Confermi?"));
});

export function useConferma() {
  return useContext(ContestoConferma);
}

export function ConfirmProvider({ children }) {
  const [richiesta, setRichiesta] = useState(null);
  const risolviRef = useRef(null);

  const conferma = useCallback((opzioni = {}) => {
    return new Promise((resolve) => {
      risolviRef.current = resolve;
      setRichiesta({ opzioni });
    });
  }, []);

  const chiudi = useCallback((esito) => {
    const risolvi = risolviRef.current;
    risolviRef.current = null;
    setRichiesta(null);
    if (risolvi) risolvi(esito);
  }, []);

  const opzioni = richiesta?.opzioni || {};

  return (
    <ContestoConferma.Provider value={conferma}>
      {children}
      <ConfirmDialog
        open={!!richiesta}
        onOpenChange={(aperto) => {
          if (!aperto) chiudi(false);
        }}
        title={opzioni.titolo || "Confermi l'operazione?"}
        description={opzioni.descrizione || "Questa azione non può essere annullata."}
        confirmText={opzioni.conferma || "Conferma"}
        cancelText={opzioni.annulla || "Annulla"}
        variant={opzioni.pericoloso === false ? "info" : "danger"}
        requireText={opzioni.testoRichiesto || null}
        details={opzioni.dettagli || null}
        onConfirm={() => chiudi(true)}
      />
    </ContestoConferma.Provider>
  );
}

export default ConfirmProvider;

